import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Animated, Text, TouchableHighlight, View } from 'react-native';

import Style from './style';
import Moment from 'moment';
import strings from '../../strings';
import { localeMoment } from '../../utilities/timeutils';
import {
  DatePicker as DatePickerWeb,
  DateTimePicker as DateTimePickerWeb,
  TimePicker,
} from '@mui/x-date-pickers';
import { designConstants } from '../../../design/styles';
import { useSelector } from 'react-redux';
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
import { toSentenceCase } from '../../utilities/stringsutils';
import useThemeContext from '../../../design/styles/useThemeContext';
import { SharedStrings } from '../../../strings/strings';
import recordStrings from '../../../modules/Records/strings';
import { createTheme, ThemeProvider } from '@mui/material/styles';

//TODO: MOVE OUT OF HERE MUI!!

const FORMATS = {
  date: 'YYYY-MM-DD',
  datetime: 'YYYY-MM-DD HH:mm',
  time: 'HH:mm',
};

const SUPPORTED_ORIENTATIONS = [
  'portrait',
  'portrait-upside-down',
  'landscape',
  'landscape-left',
  'landscape-right',
];

class DatePicker extends Component {
  constructor(props) {
    super(props);
    this.anchorRef = React.createRef();
    this.state = {
      date: this.getDate(),
      modalVisible: false,
      animatedHeight: new Animated.Value(0),
      anchorEl: 'datepicker' + Math.random().toString(16).slice(2),
    };

    this.datePicked = this.datePicked.bind(this);
    this.onPressDate = this.onPressDate.bind(this);
    this.onPressConfirm = this.onPressConfirm.bind(this);
    this.onPressCancel = this.onPressCancel.bind(this);
    this.setModalVisible = this.setModalVisible.bind(this);
  }

  UNSAFE_componentWillMount() {
    // ignore the warning of Failed propType for date of DatePickerIOS, will remove after being fixed by official
    console.ignoredYellowBox = [
      'Warning: Failed propType',
      // Other warnings you don't want like 'jsSchedulingOverhead',
    ];
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.date !== this.props.date) {
      this.setState({ date: this.getDate(nextProps.date) });
    }
  }

  setModalVisible(visible) {
    const { height, duration } = this.props;

    // slide animation
    if (visible) {
      this.setState({ modalVisible: visible });
      return Animated.timing(this.state.animatedHeight, {
        toValue: height,
        duration: duration,
      }).start();
    } else {
      return Animated.timing(this.state.animatedHeight, {
        toValue: 0,
        duration: duration,
      }).start(() => {
        this.setState({ modalVisible: visible });
      });
    }
  }

  onStartShouldSetResponder(e) {
    return true;
  }

  onMoveShouldSetResponder(e) {
    return true;
  }

  onPressConfirm() {
    //    this.setModalVisible(false);
    this.state.animatedHeight.setValue(0);
    this.setState({ modalVisible: false });
    setTimeout(() => {
      this.datePicked();
    }, 100);

    if (typeof this.props.onCloseModal === 'function') {
      this.props.onCloseModal();
    }
  }

  onPressCancel() {
    this.setModalVisible(false);

    if (typeof this.props.onCloseModal === 'function') {
      this.props.onCloseModal();
    }
    if (typeof this.props.onCanceled === 'function') {
      this.props.onCanceled();
    }
  }

  getDate(date = this.props.date) {
    const { mode, minDate, maxDate, format = FORMATS[mode] } = this.props;

    // date默认值
    if (!date) {
      let now = new Date();
      if (minDate) {
        let _minDate = this.getDate(minDate);

        if (now < _minDate) {
          return _minDate;
        }
      }

      if (maxDate) {
        let _maxDate = this.getDate(maxDate);

        if (now > _maxDate) {
          return _maxDate;
        }
      }

      return now;
    }

    if (date instanceof Date) {
      return date;
    }

    return Moment(date, format).toDate();
  }

  getDateStr(date = this.props.date) {
    const { mode, format = FORMATS[mode] } = this.props;

    if (date instanceof Date) {
      return localeMoment(Moment(date)).format(format);
    } else {
      return localeMoment(Moment(this.getDate(date))).format(format);
    }
  }

  datePicked() {
    if (typeof this.props.onDateChange === 'function') {
      setTimeout(() => {
        this.props.onDateChange(
          this.getDateStr(this.state.date),
          this.state.date,
        );
      });
    }
  }

  getTitleElement() {
    const { date, placeholder, customStyles } = this.props;

    if (!date && placeholder) {
      return (
        <Text style={[Style.placeholderText, customStyles.placeholderText]}>
          {placeholder}
        </Text>
      );
    }
    return (
      <Text style={[Style.dateText, customStyles.dateText]}>
        {this.getDateStr()}
      </Text>
    );
  }

  onPressDate() {
    if (this.props.disabled) {
      return true;
    }

    // reset state
    //Not sure why we need it - probably we can remove it but did nto tested on ios/android
    if (!designConstants.isWeb) {
      this.setState({
        date: this.getDate(),
      });
    }
    this.setModalVisible(true);

    if (typeof this.props.onOpenModal === 'function') {
      this.props.onOpenModal();
    }
  }

  renderIOSModal = () => {
    const lang =
      this.props.language === 'default'
        ? navigator.language
        : this.props.language;

    const dateFormatter = new Intl.DateTimeFormat(
      lang === 'zh-rCN' ? 'zh-Hans-CN' : lang,
      {
        dateStyle: 'long',
        timeStyle: 'long',
      },
    );

    const {
      mode,
      customStyles,
      injectedDatePickerHeaderTextIOS,
      minDate,
      maxDate,
      minuteInterval,
      timeZoneOffsetInMinutes,
      cancelBtnText,
      confirmBtnText,
    } = this.props;
    const { colors, colorTheme } = this.props.theme;

    const theme = createTheme({
      palette: {
        mode: colorTheme,
        primary: {
          main: colors.buttonBlue,
        },
      },
    });

    if (designConstants.isWeb) {
      let PickerComponent = DatePickerWeb;
      if (mode === 'time') {
        PickerComponent = TimePicker;
      } else if (mode === 'datetime') {
        PickerComponent = DateTimePickerWeb;
      }
      return (
        <ThemeProvider theme={theme}>
          <div ref={this.anchorRef}>
            <PickerComponent
              ampm={dateFormatter.resolvedOptions().hour12}
              value={localeMoment(Moment(this.state.date))}
              onClose={() => {
                if (this.props.cancelable) {
                  this.onPressCancel();
                }
              }}
              onOpen={() => {
                this.setState({ dateChanged: false });
              }}
              onAccept={() => {
                this.datePicked();
              }}
              onChange={(moment) => {
                this.setState(
                  { date: moment.toDate(), dateChanged: true },
                  () => {
                    this.datePicked();
                  },
                );
              }}
              viewRenderers={{
                hours: renderTimeViewClock,
                minutes: renderTimeViewClock,
                seconds: renderTimeViewClock,
              }}
              openTo={'hours'}
              open={this.state.modalVisible}
              timeSteps={{ minutes: 10 }}
              ref={(datePicker) => (this.datePickerWeb = datePicker)}
              slotProps={{
                actionBar: ({ wrapperVariant }) => ({
                  actions:
                    wrapperVariant === 'desktop'
                      ? [this.props.resettable && 'today']
                      : [this.props.resettable && 'today', 'cancel', 'accept'],
                }),
                popper: {
                  anchorEl: this.anchorRef.current,
                  placement: 'bottom',
                },
              }}
              localeText={{
                cancelButtonLabel: toSentenceCase(
                  SharedStrings.datepicker_cancel_button_text,
                ),
                okButtonLabel: toSentenceCase(
                  SharedStrings.datepicker_ok_button_text,
                ),
                clearButtonLabel: toSentenceCase(
                  SharedStrings.datepicker_clear_button_text,
                ),
                todayButtonLabel: toSentenceCase(
                  recordStrings.severity_slider_right_now_label,
                ),
              }}
              slots={{
                textField: (params) => {
                  return this.props.children || this.getTitleElement(params);
                },
              }}
            />
          </div>
        </ThemeProvider>
      );
    }
  };

  render() {
    const { style, customStyles, disabled } = this.props;

    const dateInputStyle = [
      Style.dateInput,
      customStyles.dateInput,
      disabled && Style.disabled,
      disabled && customStyles.disabled,
    ];

    return (
      <TouchableHighlight
        style={[Style.dateTouch, style]}
        underlayColor={'transparent'}
        onPress={this.onPressDate}
      >
        <View>
          {this.props.children}
          <View
            style={
              !this.props.children && [
                Style.dateTouchBody,
                customStyles.dateTouchBody,
              ]
            }
          >
            {!this.props.children && (
              <View style={dateInputStyle}>{this.getTitleElement()}</View>
            )}
            {this.renderIOSModal()}
          </View>
        </View>
      </TouchableHighlight>
    );
  }
}

DatePicker.defaultProps = {
  mode: 'date',
  androidMode: 'default',
  date: '',
  // component height: 216(DatePickerIOS) + 1(borderTop) + 42(marginTop), IOS only
  height: 259,

  // slide animation duration time, default to 300ms, IOS only
  duration: 300,
  confirmBtnText: strings.datepicker_ok_button_text,
  cancelable: true,
  cancelBtnText: strings.datepicker_cancel_button_text,
  iconSource: require('./date_icon.png'),
  customStyles: {},

  // whether or not show the icon
  showIcon: true,
  disabled: false,
  placeholder: '',
  modalOnResponderTerminationRequest: (e) => true,
  injectedDatePickerHeaderTextIOS: null,
};

DatePicker.propTypes = {
  mode: PropTypes.oneOf(['date', 'datetime', 'time']),
  androidMode: PropTypes.oneOf(['calendar', 'spinner', 'default']),
  date: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
    PropTypes.object,
  ]),
  format: PropTypes.string,
  minDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  maxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  height: PropTypes.number,
  duration: PropTypes.number,
  confirmBtnText: PropTypes.string,
  cancelable: PropTypes.bool,
  cancelBtnText: PropTypes.string,
  iconSource: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  customStyles: PropTypes.object,
  showIcon: PropTypes.bool,
  disabled: PropTypes.bool,
  onDateChange: PropTypes.func,
  onOpenModal: PropTypes.func,
  onCloseModal: PropTypes.func,
  onCanceled: PropTypes.func,
  placeholder: PropTypes.string,
  modalOnResponderTerminationRequest: PropTypes.func,
  is24Hour: PropTypes.bool,
  injectedDatePickerHeaderTextIOS: PropTypes.string,
};

const ConnectedDatePicker = React.forwardRef((props, ref) => {
  const language = useSelector((state) => state.settings.language);
  const theme = useThemeContext();
  return <DatePicker {...props} theme={theme} language={language} ref={ref} />;
});

export default ConnectedDatePicker;
